// Mirrors caseblink/services/entitlements_service.py::Feature on the backend.
export enum Feature {
  DOCUMENT_MANAGEMENT = "document_management",
  PACKET_ASSEMBLY = "packet_assembly",
  DOCUMENT_VERIFICATION = "document_verification",
  CASE_STRATEGY = "case_strategy",
  CASE_RESEARCH = "case_research",
  USCIS_FORMS = "uscis_forms",
  // Every draft type, including RFE / NOID / NOIR responses, expert letters
  // and employment verification letters.
  DRAFTING = "drafting",
  ATHENA = "athena",
  DOCUMENTS_AI_ORGANIZER = "documents_ai_organizer"
}

export const LITE_PLAN_TYPE = "Lite";

export type Entitlements = {
  planType: string | null;
  features: string[];
};
